














































import {
  computed,
  defineComponent,
  ref,
  useRoute
} from '~/utils/nuxt3-migration'
import CDropdownMenu from '~/components/shared/configurable/dropdown/CDropdownMenu.vue'
import CDropdownMenuItem from '~/components/shared/configurable/dropdown/CDropdownMenuItem.vue'
import CBreadcrumbs from '~/components/shared/configurable/CBreadcrumbs.vue'
import { useI18n } from '~/compositions/i18n'
import { Breadcrumb } from '~/models/common/types'
import { useNamespacedStore } from '~/compositions/store'
import { USER_NS, UserState } from '~/store/modules/shared/user/state'

interface Page {
  path?: string
  nuxtLink?: boolean
  label?: string
  showForManagersAndAdmins?: boolean
  children?: {
    label: string
    path: string
    nuxtLink: boolean
  }[]
}

export default defineComponent({
  components: {
    CBreadcrumbs,
    CDropdownMenu,
    CDropdownMenuItem
  },
  setup() {
    const route = useRoute()
    const { t } = useI18n()
    const { getters } = useNamespacedStore<UserState>(USER_NS)

    const userIsManagerOrAdmin = computed(
      () => getters('isManager') || getters('isAdmin')
    )

    const pages = ref<Page[]>([
      {
        label: t('support').toString(),
        path: '/information/contact',
        nuxtLink: true
      },
      {
        label: t('dealer registration').toString(),
        path: '/dealers/register',
        nuxtLink: true
      },
      {
        label: t('register your business').toString(),
        path: '/cartalog/register/',
        nuxtLink: false
      },
      {
        label: t('subscription renewal').toString(),
        path: '/information/renew/',
        nuxtLink: false,
        showForManagersAndAdmins: true
      },
      {
        label: t('market guide').toString(),
        path: '/information/simboulos',
        nuxtLink: true
      },
      {
        label: t('frequently asked questions').toString(),
        children: [
          {
            label: t('users faq').toString(),
            path: '/information/users_faq',
            nuxtLink: true
          },
          {
            label: t('dealers faq').toString(),
            path: '/information/dealers_faq',
            nuxtLink: true
          }
        ]
      },
      {
        label: t('job offers').toString(),
        path: '/information/careers',
        nuxtLink: true
      },
      {
        label: t('terms and conditions').toString(),
        path: '/information/terms',
        nuxtLink: true
      },
      {
        label: t('privacy policy').toString(),
        path: '/information/privacy',
        nuxtLink: true
      }
    ])

    const initialBreadcrumb: Breadcrumb[] = [
      {
        url: '/information/contact',
        text: t('information').toString()
      },
      {
        url: '/information/contact',
        text: t('support').toString()
      }
    ]

    const selectedTab = computed(() => route.value.path)
    const dropdownActive = computed(() => {
      const parentPage = pages.value.find(page => page.children)
      if (parentPage) {
        return parentPage.children?.some(
          child => child.path === selectedTab.value
        )
      } else {
        return false
      }
    })
    const breadcrumbs = computed(() => {
      const [infoBC] = initialBreadcrumb
      const activePages = pages.value
        .filter(p =>
          p.children
            ? p.children.find(c => c.path === selectedTab.value)
            : p.path === selectedTab.value
        )
        .map(item => {
          if (item.children) {
            const activeChild = item.children.find(
              c => c.path === selectedTab.value
            ) as Page
            const { path, label } = activeChild
            return {
              url: path,
              text: label
            }
          }
          return { url: item.path, text: item.label }
        })
      const newBreadcrumb = [infoBC, ...activePages]
      return newBreadcrumb
    })
    const computedPages = computed(() =>
      userIsManagerOrAdmin.value
        ? pages.value
        : pages.value.filter(page => !page.showForManagersAndAdmins)
    )

    return {
      selectedTab,
      dropdownActive,
      breadcrumbs,
      userIsManagerOrAdmin,
      computedPages
    }
  }
})
